import React from "react";
import Navbar from "../Components/Navbar/Navbar";

const Latest = () => {
  return (
    <div>
      <Navbar label="Sign In" />
      <h1>Latest tour will go there</h1>
    </div>
  );
};

export default Latest;
